import React, { useContext } from 'react';

import { Helmet } from 'react-helmet';
import { VisualizacaoContext } from '../Context';

function Title() {
  const { codigoConsulta } = useContext(VisualizacaoContext);
  return (
    <Helmet>
      <title>
        {codigoConsulta
          ? `Visualização de Certificado - ${codigoConsulta} - Meus Docs`
          : 'Visualização de Certificado - Meus Docs'}
      </title>
    </Helmet>
  );
}

export default Title;
